import * as React from 'react';
import {Fragment, useEffect, useState} from "react";
import Input from "../../../components/common/Input/Input";
import InputUtils, {Type} from "../../../InputUtils";
import './registerUser.css'
import {getAllCountries, getAllTenantsPublic, registerUser} from "../../../actions/boCoreActions";
import history from "../../../config/history";
import {PublicRoutes} from "../../../config/routes";
import Utils from "../../../Utils";



const RegisterUser = () => {
    const [form, setForm] = useState(JSON.parse(JSON.stringify(defaultForm)))
    const [showOrganizationOptions, setShowOrganizationOptions] = useState<boolean>(false);

    useEffect(() => {
        if (!window.location.origin.includes('panalax')) {
            setShowOrganizationOptions(true);
            getData()
                .then(responses => {
                    const formCopy = JSON.parse(JSON.stringify(form));
                    formCopy.tenants.options = responses[0].data.map((tenant) => {
                        return {
                            id: tenant.id,
                            value: tenant.id,
                            label: tenant.name
                        }
                    })
                    formCopy.parentOrganization.options = JSON.parse(JSON.stringify(formCopy.tenants.options))
                        .filter(tenant => tenant.label !== 'multi-tenant-group' && tenant.label !== 'Default')
                    formCopy.countryOwnOrganization.options = responses[1].data.map((country) => {
                        return {
                            id: country.id,
                            value: country.id,
                            label: country.name
                        }
                    }).sort((a, b) => a.label.localeCompare(b.label))
                    setForm(formCopy)
                })
        } else {
            getAllCountries()
                .then(response => {
                    const formCopy = JSON.parse(JSON.stringify(form));
                    formCopy.countryOwnOrganization.options = response.data.map((country) => {
                        return {
                            id: country.id,
                            value: country.id,
                            label: country.name
                        }
                    }).sort((a, b) => a.label.localeCompare(b.label));
                    formCopy.organizationType.value = organizationTypeOptions[1];
                    setForm(formCopy)
                })
        }
    }, [])

    const getData = async () => {
        return await Promise.all([
            getAllTenantsPublic(),
            getAllCountries()
        ])
    }

    const onChange = (event, id, inputType) => {
        const formCopy = JSON.parse(JSON.stringify(form));
        let eventValue;
        if (inputType === 'select') {
            eventValue = event ? event : [];
            if (id === 'organizationType') {
                if (eventValue.value === 'own') {
                    formCopy.tenants.value = [];
                    formCopy.organizationType.options = [organizationTypeOptions[0]];
                } else {
                    formCopy.organizationType.options = [organizationTypeOptions[1]];
                }
                resetAdditionalFields(formCopy);
            }
        } else if (inputType === 'inputSwitch') {
            if (event.target.value === 'true') {
                eventValue = 0;
                if (id === 'hasParentOrganization') {
                    formCopy.parentOrganization.value = null;
                }
            } else {
                eventValue = 1;
            }
        } else {
            eventValue = event.target.value;
        }

        setForm({
            ...formCopy,
            [id]: {
                ...formCopy[id],
                value: eventValue,
                valid: true
            }
        });
    }

    const resetAdditionalFields = (formRef: any) => {
        const keys = Object.keys(formRef);
        keys.forEach((key, index) => {
            switch (key) {
                case 'legalCompanyNameOwnOrganization':
                    if (formRef[key].valid === false) {
                        formRef[key].value = '';
                    }
                    formRef[key].valid = true;
                    break;
                case 'taxIdOwnOrganization':
                    if (formRef[key].valid === false) {
                        formRef[key].value = '';
                    }
                    formRef[key].valid = true;
                    break;
                case 'countryOwnOrganization':
                    if (formRef[key].valid === false) {
                        formRef[key].value = '';
                    }
                    formRef[key].valid = true;
                    break;
                case 'parentOrganization':
                    if (formRef[key].valid === false) {
                        formRef[key].value = '';
                    }
                    formRef[key].valid = true;
                    break;
                case 'tenants':
                    if (formRef[key].valid === false) {
                        formRef[key].value = '';
                    }
                    formRef[key].valid = true;
                    break;
            }
        })
    }

    const checkFormValidity = (): boolean => {
        const keys = Object.keys(form);
        const formCopy = JSON.parse(JSON.stringify(form));
        let formIsValid = true;
        keys.forEach((key, index) => {
            switch (key) {
                case 'firstName':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'lastName':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'userName':
                    if (formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'email':
                    const str = formCopy[key].value;
                    if (!InputUtils.EMAIL_REGEX.test(str)) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'tenants':
                    if ((formCopy.organizationType.value.value === 'join' && formCopy.hasParentOrganization.value === 0) && formCopy[key].value.length === 0) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'legalCompanyNameOwnOrganization':
                    if (formCopy.organizationType.value.value === 'own' && formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'taxIdOwnOrganization':
                    if (formCopy.organizationType.value.value === 'own' && formCopy[key].value === '') {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'countryOwnOrganization':
                    if (formCopy.organizationType.value.value === 'own' && formCopy[key].value === null) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'parentOrganization':
                    if (formCopy.hasParentOrganization.value === 1 && formCopy[key].value === null) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'timezone':
                    if (formCopy.organizationType.value.value === 'own' && formCopy[key].value === null) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
                case 'password':
                    const pass = formCopy[key].value;
                    if (!InputUtils.PASSWORD_REGEX.test(pass)) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break
                case 'confirmPass':
                    if (formCopy[key].value !== formCopy[keys[index - 1]].value) {
                        formCopy[key].valid = false;
                        formIsValid = false;
                    }
                    break;
            }
        })

        setForm(formCopy)
        return formIsValid;
    }

    const toLogin = () => {
        history.push(`${process.env.ENV_PREFIX}${PublicRoutes.LOGIN}`)
    }

    const getTenantsIds = (tenants) => {
        return tenants.map(tenant => {
            return tenant.id;
        })
    }

    const register = () => {
        if (checkFormValidity()) {
            const dto = {
                email: form.email.value,
                firstName: form.firstName.value,
                hasParentOrganization: form.hasParentOrganization.value === 1,
                joinOrganizations: getTenantsIds(form.tenants.value),
                lastName: form.lastName.value,
                organization: form.organizationType.value.value === 'own' ? {
                    legalCompanyName: form.legalCompanyNameOwnOrganization.value,
                    name: form.legalCompanyNameOwnOrganization.value,
                    taxId: form.taxIdOwnOrganization.value,
                    countryId: form.countryOwnOrganization.value ? form.countryOwnOrganization.value.id : null,
                    timeZone: form.timezone.value ? form.timezone.value.value : '',
                    webSite: form.ownOrganizationWebsite.value
                } : null,
                ownOrganization: form.organizationType.value.value === 'own',
                parentOrganizationId: form.parentOrganization.value ? form.parentOrganization.value.id : null,
                password: form.password.value,
                username: form.userName.value,
            }

            registerUser(dto)
                .then(() => {
                    Utils.$.confirm({
                        title: 'Congratulations!',
                        keyboardEnabled: true,
                        escapeKey: 'cancel',
                        backgroundDismiss: false,
                        content: 'Your account has been successfully created.',
                        type: 'green',
                        theme: 'dark',
                        typeAnimated: false,
                        buttons: {
                            ok: {
                                text: "Ok!",
                                btnClass: 'btn-primary',
                                keys: ['enter'],
                                action: () => {
                                    toLogin();
                                }
                            },
                        }
                    });
                })
        }
    }

    const renderJoinOrganizationFields = () => {
        return <Fragment>
            <Input id={'organizationType'}
                   value={form.organizationType.value}
                   required={true}
                   elementType={Type.SELECT}
                   changed={(event) => onChange(event, 'organizationType', 'select')}
                   classNameProp={'input-full-width margin-input-for-label'}
                   valid={form.organizationType.valid}
                   errorMsg={form.organizationType.errorMsg}
                   selectInitialPosition={true}
                   label={'Join Existing or Create a New Organization'}
                   elementConfig={{
                       placeholder: '',
                       tabIndex: 7,
                       options: form.organizationType.options,
                   }}
            />
            {form.organizationType.value.value === 'join' ? <Input id={'tenant'}
                                                                   value={form.tenants.value}
                                                                   required={true}
                                                                   elementType={Type.SELECT}
                                                                   changed={(event) => onChange(event, 'tenants', 'select')}
                                                                   classNameProp={'input-full-width margin-input-for-label'}
                                                                   valid={form.tenants.valid}
                                                                   errorMsg={form.tenants.errorMsg}
                                                                   selectInitialPosition={true}
                                                                   label={'Select Organizations'}
                                                                   elementConfig={{
                                                                       placeholder: 'Organizations',
                                                                       tabIndex: 8,
                                                                       options: form.tenants.options,
                                                                       isMulti: true,
                                                                       closeMenuOnSelect: false,
                                                                   }}
            /> : null}
        </Fragment>
    }

    const renderParentSwitch = () => {
        return form.organizationType.value.value === 'own' ?
                <div className={'register-switch-container'} style={{display: 'inline-block'}}>
                    <Input id={'hasParentOrganization'}
                           value={form.hasParentOrganization.value === 1 ? "true" : "false"}
                           required={false}
                           elementType={Type.INPUT_SWITCH}
                           changed={(event) => onChange(event, 'hasParentOrganization', 'inputSwitch')}
                           classNameProp={'input-full-width margin-input-for-label'}
                           labelExtraClass={'fullWidthLabel'}
                           label={'Has Parent Organization'}
                           wrapperClass={form.hasParentOrganization.value === 1 ? 'half-width-float-left' : ''}
                           elementConfig={{
                               tabIndex: 14
                           }}
                    />
                    {form.hasParentOrganization.value === 1 ?
                        <Input id={'parentOrganization'}
                               value={form.parentOrganization.value}
                               required={true}
                               elementType={Type.SELECT}
                               changed={(event) => onChange(event, 'parentOrganization', 'select')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.parentOrganization.valid}
                               errorMsg={form.parentOrganization.errorMsg}
                               selectInitialPosition={true}
                               label={'Select Parent Organization'}
                               wrapperClass={'half-width'}
                               elementConfig={{
                                   placeholder: 'Organizations',
                                   tabIndex: 15,
                                   options: form.parentOrganization.options,
                                   menuPlacement: 'top'
                               }}
                        /> : null}
                </div> : null
    }

    return (
        <div style={{height: '100vh'}}>
            <div className={'register-image register-background'}/>

            <div className={'register-wrapper'}>
                <div className={'register-container'}>
                    <h1 style={{fontSize: 30, color: '#adadad', marginTop: 0, textAlign: 'center'}}>Sign Up</h1>
                    <div style={{borderBottom: "2px solid #3D6367"}}/>
                    <div className={'register-user-form'}>
                        <Input id={'firstName'}
                               value={form.firstName.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'firstName', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.firstName.valid}
                               errorMsg={form.firstName.errorMsg}
                               wrapperClass={'half-width-float-left'}
                               label={'First Name'}
                               elementConfig={{
                                   placeholder: 'First Name',
                                   tabIndex: 1
                               }}
                        />
                        <Input id={'lastName'}
                               value={form.lastName.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'lastName', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.lastName.valid}
                               errorMsg={form.lastName.errorMsg}
                               wrapperClass={'half-width'}
                               label={'Last Name'}
                               elementConfig={{
                                   placeholder: 'Last Name',
                                   tabIndex: 2
                               }}
                        />
                        <Input id={'userName'}
                               value={form.userName.value}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'userName', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               required={true}
                               valid={form.userName.valid}
                               errorMsg={form.userName.errorMsg}
                               wrapperClass={'half-width-float-left'}
                               label={'Username'}
                               elementConfig={{
                                   placeholder: 'Username',
                                   tabIndex: 3
                               }}
                        />
                        <Input id={'email'}
                               value={form.email.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'email', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.email.valid}
                               errorMsg={form.email.errorMsg}
                               wrapperClass={'half-width'}
                               label={'Email'}
                               elementConfig={{
                                   placeholder: 'Email',
                                   tabIndex: 4
                               }}
                        />
                        <Input id={'password'}
                               value={form.password.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'password', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               valid={form.password.valid}
                               errorMsg={form.password.errorMsg}
                               wrapperClass={'half-width-float-left'}
                               label={'Password'}
                               elementConfig={{
                                   placeholder: 'Password',
                                   tabIndex: 5,
                                   type: 'password',
                                   autoComplete: "new-password"
                               }}
                        />
                        <Input id={'confirmPass'}
                               value={form.confirmPass.value}
                               required={true}
                               elementType={Type.INPUT}
                               changed={(event) => onChange(event, 'confirmPass', 'input')}
                               classNameProp={'input-full-width margin-input-for-label'}
                               errorMsg={form.confirmPass.errorMsg}
                               label={'Confirm Password'}
                               valid={form.confirmPass.valid}
                               wrapperClass={'half-width'}
                               elementConfig={{
                                   placeholder: 'Confirm Password',
                                   tabIndex: 6,
                                   type: 'password'
                               }}
                        />
                        {showOrganizationOptions ? renderJoinOrganizationFields() : null}
                        {form.organizationType.value.value === 'own' ?
                            <div className={'organization-fields'}>
                                <h5>New organization</h5>
                                <hr/>
                                <Input id={'legalCompanyNameOwnOrganization'}
                                       value={form.legalCompanyNameOwnOrganization.value}
                                       required={true}
                                       elementType={Type.INPUT}
                                       changed={(event) => onChange(event, 'legalCompanyNameOwnOrganization', 'input')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       valid={form.legalCompanyNameOwnOrganization.valid}
                                       errorMsg={form.legalCompanyNameOwnOrganization.errorMsg}
                                       wrapperClass={'half-width-float-left'}
                                       label={'Company Name'}
                                       elementConfig={{
                                           placeholder: 'Company Name',
                                           tabIndex: 9
                                       }}
                                />
                                <Input id={'taxIdOwnOrganization'}
                                       value={form.taxIdOwnOrganization.value}
                                       required={true}
                                       elementType={Type.INPUT}
                                       changed={(event) => onChange(event, 'taxIdOwnOrganization', 'input')}
                                       classNameProp={'input-full-width margin-input-for-label'}
                                       valid={form.taxIdOwnOrganization.valid}
                                       errorMsg={form.taxIdOwnOrganization.errorMsg}
                                       wrapperClass={'half-width'}
                                       label={'Tax ID'}
                                       elementConfig={{
                                           placeholder: 'Tax ID',
                                           tabIndex: 10
                                       }}
                                />
                                <div className={'multiple-fields'}>
                                    <Input id={'countryOwnOrganization'}
                                           value={form.countryOwnOrganization.value}
                                           required={true}
                                           elementType={Type.SELECT}
                                           changed={(event) => onChange(event, 'countryOwnOrganization', 'select')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={form.countryOwnOrganization.valid}
                                           errorMsg={form.countryOwnOrganization.errorMsg}
                                           selectInitialPosition={true}
                                           label={'Select Country'}
                                           elementConfig={{
                                               placeholder: 'Countries',
                                               tabIndex: 11,
                                               options: form.countryOwnOrganization.options,
                                               filterOption:Utils.filterOptions
                                           }}
                                    />
                                    <div className={'multiple-fields-spacer'}/>
                                    <Input id={'timezone'}
                                           value={form.timezone.value}
                                           required={true}
                                           elementType={Type.SELECT}
                                           changed={(event) => onChange(event, 'timezone', 'select')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           errorMsg={form.timezone.errorMsg}
                                           valid={form.timezone.valid}
                                           selectInitialPosition={true}
                                           label={'Default Timezone'}
                                           elementConfig={{
                                               placeholder: 'Select Default Timezone',
                                               isMulti: false,
                                               closeMenuOnSelect: true,
                                               tabIndex: 12,
                                               options: Utils.moment_timezone.tz.names().map(tz => {
                                                   return {
                                                       label: `${tz} (GMT${Utils.moment_timezone.tz(tz).format('Z')})`,
                                                       value: tz
                                                   }
                                               })
                                           }}
                                    />
                                    <div className={'multiple-fields-spacer'}/>
                                    <Input id={'ownOrganizationWebsite'}
                                           value={form.ownOrganizationWebsite.value}
                                           required={false}
                                           elementType={Type.INPUT}
                                           changed={(event) => onChange(event, 'ownOrganizationWebsite', 'input')}
                                           classNameProp={'input-full-width margin-input-for-label'}
                                           valid={form.ownOrganizationWebsite.valid}
                                           errorMsg={form.ownOrganizationWebsite.errorMsg}
                                           label={'Website'}
                                           elementConfig={{
                                               placeholder: 'Website',
                                               tabIndex: 13
                                           }}
                                    />
                                </div>
                            </div> : null}
                        {showOrganizationOptions ? renderParentSwitch() : null}
                    </div>
                    <footer style={{
                        borderTop: "2px solid #3D6367",
                        height: 49,
                        width: "100%",
                        paddingTop: 3,
                        marginTop: 10
                    }}>
                        <button
                            onClick={register}
                            className={"btn"}
                            id={"btn-save"}
                            style={{float: "right", marginTop: 3, marginLeft: 4}}>
                            <i className="fas fa-address-card-o"> Sign up</i>
                        </button>
                        <button
                            onClick={toLogin}
                            className={"btn"}
                            style={{float: "right", marginTop: 3, marginRight: 2}}>
                            <i className="fas fa-arrow-left"> Back</i>
                        </button>
                    </footer>
                </div>
            </div>
        </div>
    );
};

const organizationTypeOptions = [
    {
        value: 'join',
        label: 'Join Existing'
    },
    {
        value: 'own',
        label: 'Create New Organization'
    },
]

const defaultForm = {
    firstName: {
        value: '',
        valid: true,
        errorMsg: 'First name cannot be empty'
    },
    lastName: {
        value: '',
        valid: true,
        errorMsg: 'Last name cannot be empty',
    },
    userName: {
        value: '',
        valid: true,
        errorMsg: 'Username name cannot be empty',
    },
    password: {
        value: '',
        valid: true,
        errorMsg: 'Password length must be at least 4 characters',
    },
    confirmPass: {
        value: '',
        valid: true,
        errorMsg: 'Passwords do not match',
    },
    email: {
        value: '',
        valid: true,
        errorMsg: 'Invalid email address',
    },
    tenants: {
        value: [],
        valid: true,
        errorMsg: 'Please select organization',
        options: [],
    },
    hasParentOrganization: {
        value: 0,
        valid: true
    },
    parentOrganization: {
        value: null,
        valid: true,
        errorMsg: 'Please select parent organization',
        options: [],
    },
    legalCompanyNameOwnOrganization: {
        value: '',
        valid: true,
        errorMsg: 'Legal company name cannot be empty'
    },
    ownOrganizationWebsite: {
        value: '',
        valid: true,
        errorMsg: 'Website field cannot be empty'
    },
    taxIdOwnOrganization: {
        value: '',
        valid: true,
        errorMsg: 'Tax ID cannot be empty'
    },
    countryOwnOrganization: {
        value: null,
        valid: true,
        errorMsg: 'Country field cannot be empty',
        options: [],
    },
    timezone: {
        value: null,
        valid: true,
        errorMsg: 'Timezone field cannot be empty',
    },
    organizationType: {
        value: organizationTypeOptions[0],
        valid: true,
        errorMsg: 'Organization type cannot be empty',
        options: [organizationTypeOptions[1]]
    },
}

export default RegisterUser;



// WEBPACK FOOTER //
// ./app/views/bo-core/registerUser/RegisterUser.tsx